import { lazy } from "react"
import type { FC, LazyExoticComponent } from "react"

async function loader(): Promise<{ default: FC }> {
    return import("./assistant.participants.page").then(({ AssistantParticipantsPage: APP }): { default: FC } => ({
        default: APP
    }))
}

const AssistantParticipantsPage: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => loader())

export {
    assistantParticipantsQueryPrefetcher,
    assistantParticipantsQueryInvalidator
} from "./assistant.participants.api.queries.hooks"

export { AssistantParticipantsPage }

async function assistantParticipantsPagePreloader(): Promise<void> {
    await loader()
}

export { assistantParticipantsPagePreloader }
